import { DeepPartial, PhantomComponentsConfig } from '@empathybroker/ebx-gluon';
import { Vue } from 'vue-property-decorator';

export const DEFAULT_PHANTOM_COMPONENTS_CONFIG: DeepPartial<PhantomComponentsConfig> = {
  components: {
    classBinder: {
      data: {
        props: {
          dynamicClasses: {
            'empathy-x--facets-opened': (self: Vue) => !self.$store.state.search.facetsGroups['all-facets'].collapsed
          }
        }
      }
    }
  }
};
